module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_arrow_down-c3902a4efe5cc1b657c0bc22083510e8.svg";